;(function() {
  'use strict'

  Controller.$inject = ["$q", "$state", "glAnalytics", "StateFactory", "channelService", "products", "locationService", "geocodeService", "placeService"];
  angular.module('app.zone').component('zoneSearch', {
    controller: Controller,
    templateUrl: 'zone-search.html',
    bindings: {
      code: '<',
      theme: '<',
    },
  })

  /* @ngInject */
  function Controller(
    $q,
    $state,
    glAnalytics,
    StateFactory,
    channelService,
    products,
    locationService,
    geocodeService,
    placeService
  ) {
    var ctrl = this

    var SearchTypes = products.SearchTypes
    var HardCodes = {
      12345: 'https://glo.link/afgc',
    }

    ctrl.$onInit = onInit
    ctrl.selectPlacesFeedback = selectPlacesFeedback
    ctrl.searchNearby = searchNearby
    ctrl.selectPlace = selectPlace
    ctrl.searchProduct = searchProduct
    ctrl.selectProduct = selectProduct
    ctrl.onScan = onScan
    ctrl.reset = reset

    function onInit() {
      ctrl.state = new StateFactory(['select', 'places', 'products'])
      ctrl.buttonStyle = {
        backgroundColor: ctrl.theme.buttonBackgroundColor,
      }
      ctrl.inputStyle = {
        border: '2px solid ' + ctrl.theme.inputBorderColor,
      }
      ctrl.canScan = !!(navigator && navigator.mediaDevices)
      ctrl.state.select()
    }

    function track(action, label) {
      glAnalytics.track('Zone', action, label)
    }

    function selectPlacesFeedback() {
      ctrl.state.places()
      searchNearby()
    }

    function searchNearby() {
      if (ctrl.isLoading) {
        return
      }
      ctrl.placesError = null
      ctrl.isLoading = true
      locationService
        .get(true, true)
        .then(function(location) {
          track('searchNearby', 'browser-location-enabled')
          var coords = location.position.coords

          geocodeService
            .getLocalityFromLocation(coords.latitude, coords.longitude)
            .then(function(locality) {
              if (!locality) {
                return
              }
              var localityComponents = [locality.suburb, locality.state]
              ctrl.localityName = _.pull(localityComponents, undefined).join(
                ', '
              )
            })

          placeService
            .getNearLocation(coords)
            .then(makePlacesResults)
            .then(function(places) {
              ctrl.places = places
            })
            .catch(function() {
              ctrl.placesError = 'Oops, something went wrong. Please try again.'
            })
            .finally(function() {
              ctrl.isLoading = false
            })
        })
        .catch(function() {
          track('searchNearbyError', 'browser-location-disabled')
          ctrl.isLoading = false
          ctrl.placesError =
            "We can't find your location. Please ensure location services are turned on and try again."
        })
    }

    function makePlacesResults(places) {
      // Catch each error here so that $q.all below doesn't fall over
      var promises = _.map(places, function(place) {
        return channelService
          .getByPlace(place.id)
          .then(function(channel) {
            if (!channel.enabled) {
              return
            }
            return {
              name: place.name,
              address: place.address.address,
              distance: place.getFormattedDistance(),
              channelId: channel.id,
              surveyId: channel.survey.id,
              id: place.id,
            }
          })
          .catch(function() {
            return
          })
      })
      return $q.all(promises).then(function(results) {
        return _.pull(results, undefined)
      })
    }

    function selectPlace(place) {
      track(
        'SelectedPlace',
        'place: ' + place.id + ' channel: ' + place.channelId
      )
      $state.go('app.survey', {
        id: place.surveyId,
        place: place.id,
        channelId: place.channelId,
      })
    }

    function searchProduct(query) {
      reset()

      if (!query || query.length < 5) {
        return
      }

      if (HardCodes[query]) {
        window.location.href = HardCodes[query]
        return
      }

      // Track after checking for hard codes because we don't want to track those
      track('SearchedProduct', 'query: ' + ctrl.code)

      ctrl.isLoading = true
      products
        .search(query, SearchTypes.SUFFIX)
        .then(makeProductsResults)
        .then(function(products) {
          if (!products.length) {
            return $q.reject()
          }
          if (products.length === 1) {
            selectProduct(products[0])
          } else {
            ctrl.products = products
            ctrl.message = 'Which one is it?'
          }
        })
        .catch(function() {
          track('SearchProductError', 'query: ' + ctrl.code)
          ctrl.message = 'Oops, we dont know that code.'
        })
        .finally(function() {
          ctrl.isLoading = false
        })
    }

    function makeProductsResults(products) {
      // Catch each error here so that $q.all below doesn't fall over
      var promises = _.map(products, function(product) {
        return channelService
          .getByProduct(product.id)
          .then(function(channel) {
            if (!channel.enabled) {
              return
            }
            return {
              brand: product.brand,
              name: product.name,
              gtin: product.gtin,
              channelId: channel.id,
              surveyId: channel.survey.id,
              id: product.id,
            }
          })
          .catch(function() {
            return
          })
      })
      return $q.all(promises).then(function(results) {
        return _.pull(results, undefined)
      })
    }

    function selectProduct(product) {
      track(
        'SelectedProduct',
        'query: ' +
          ctrl.code +
          ' product: ' +
          product.id +
          ' channel: ' +
          product.channelId
      )
      $state.go('app.survey', {
        id: product.surveyId,
        product: product.id,
        channelId: product.channelId,
      })
    }

    function onScan(code) {
      if (code) {
        ctrl.code = code.substr(-5)
      }
      ctrl.scannerVisible = false
      ctrl.searchProduct(code)
    }

    function reset() {
      ctrl.products = null
      ctrl.message = null
    }
  }
})()
